import React, { useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import BigNumber from "bignumber.js";
import { FormattedMessage } from 'react-intl';
import Countdown, { zeroPad } from 'react-countdown';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  countDownRendererRoot: {
    display: 'table',
    flexWrap: 'wrap',
    margin: 'auto',
    padding: theme.spacing(0, 2),
    borderCollapse: "separate",
    // borderSpacing: theme.spacing(1) + "px 0",
    '& > .main': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    '& > .sub': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(4),
      height: theme.spacing(8),
    },
  },
  countDownRendererFooterRoot: {
    display: 'table',
    flexWrap: 'wrap',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 5),
    },
    borderCollapse: "separate",
    // borderSpacing: theme.spacing(1) + "px 0",
    '& > .main': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(8),
      height: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        fontSize: "7px"
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: "0.75"
      },
    },
    '& > .sub': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
  countDownOuter: {
    padding: theme.spacing(4)
  },
  title: {
  },
  subTitle: {
    display: 'table',
    margin: "auto"
  },
  progress: {
    width:"80%",
    margin: theme.spacing(4,"auto"),
    padding: theme.spacing(2)
  },
}));

const TokenSalesHeader = ({ readSales, config }) => {
  // const unlockTime = 1625308331000//1635638400000;
  const [address, setAddress] = useState()
  const [progress, setProgress] = useState(30)
  // const [cap, setCap] = useState("10000000000")
  // const [goal, setGoal] = useState("30000000")
  const [isOpen, setIsOpen] = useState(false)
  const [loadedCountDown, setLoadedCountDown] = useState(false)
  const [countdownDate, setCountdownDate] = useState(Number.MIN_SAFE_INTEGER)
  const [openTime, setdOpeningTime] = useState(Number.MIN_SAFE_INTEGER)
  const [closeTime, setClosingTime] = useState(Number.MIN_SAFE_INTEGER)
  const classes = useStyles();

  const setState = async () => {
    refreshCountDown(openTime,closeTime)
    if (readSales && address !== readSales._address) {
      setAddress(readSales._address);

      const soldToken = new BigNumber(await readSales.methods.soldTokens().call())
      const cap_ = new BigNumber(await readSales.methods.cap().call())
      // setCap(cap_)
      if (soldToken !== 0) {
        const progressCap = (cap_.div(new BigNumber(10).pow(18)).div(soldToken).multipliedBy(100))
        setProgress(30 + (progressCap > 30 ? progressCap - 30 : 0))
      }

      // setCap(new BigNumber(await readSales.methods.cap().call()).div(new BigNumber(10).pow(18)).toString(10));
      // setGoal(new BigNumber(await readSales.methods.goal().call()).div(new BigNumber(10).pow(18)).toString(10));
      const _openingTime = await readSales.methods.openingTime().call() * 1000
      setdOpeningTime(_openingTime);
      const _closingTime = await readSales.methods.closingTime().call() * 1000
      setClosingTime(_closingTime);
      // const _tokenUnlockTime = await readSales.methods.tokenUnlockTime().call() * 1000
      // setTokenUnlockTime(new Date(_tokenUnlockTime).toLocaleString());
      refreshCountDown(_openingTime, _closingTime)

    }
  }
  const refreshCountDown = (_openTime,_closeTime/*, unlockTome */) => {
    if (Date.now() < _openTime) {
      setCountdownDate(_openTime)
      setLoadedCountDown(true)
    } else if (Date.now() < _closeTime) {
      setIsOpen(true)
      setCountdownDate(_closeTime)
      // setCountdownDate(Number.MIN_SAFE_INTEGER)
    }
    // else if (Date.now() < unlockTime) {
    //   setCountdownDate(unlockTime)
    // }
    else {
      setIsOpen(false)
      setCountdownDate(Number.MIN_SAFE_INTEGER)
    }
  }
  const countDownRenderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div>
        <Paper className={classes.countDownRendererRoot}>
          <Typography className="main" color="primary" variant="h4" align="center">
            {zeroPad(days)}
          </Typography>
          <Typography className="sub" variant="h6" align="center">
            :
          </Typography>
          <Typography className="main" color="primary" variant="h4" align="center">
            {zeroPad(hours)}
          </Typography>
          <Typography className="sub" variant="h6" align="center">
            :
          </Typography>
          <Typography className="main" color="primary" variant="h4" align="center">
            {zeroPad(minutes)}
          </Typography>
          <Typography className="sub" variant="h6" align="center">
            :
          </Typography>
          <Typography className="main" color="primary" variant="h4" align="center">
            {zeroPad(seconds)}
          </Typography>
        </Paper>
        <Container className={classes.countDownRendererFooterRoot}>
          <Typography variant="caption" className="main" align="center">
            DAYS
          </Typography>
          <Typography className="sub" align="center">
          </Typography>
          <Typography variant="caption" className="main" align="center">
            HOURS
          </Typography>
          <Typography className="sub" align="center">
          </Typography>
          <Typography variant="caption" className="main" align="center">
            MINUTES
          </Typography>
          <Typography className="sub" align="center">
          </Typography>
          <Typography variant="caption" className="main" align="center">
            SECONDS
          </Typography>
        </Container>
      </div>
    )
  }
  useEffect(() => {
    setState()
  })

  return (
    <Container>
      <div className={classes.subTitle}>
        <Typography color="primary" variant="h4">
          Eartha(EAR)
          </Typography>
      </div>
      {isOpen &&
        <div className={classes.subTitle} style={{ marginTop: "5px" }}>
          <Typography variant="h5">
            <img src="../assets/fire.gif" height={64} width={32} />
            <img src="../assets/fire.gif" height={64} width={32} />
            LIVE
            <img src="../assets/fire.gif" height={64} width={32} />
            <img src="../assets/fire.gif" height={64} width={32} />
          </Typography>
        </div>
      }
      <div className={classes.subTitle} style={{ marginTop: "32px" }}>
        <Typography variant="h5">
          PRESALE
        </Typography>
      </div>
      <div className={classes.subTitle} style={{ marginBottom: "64px" }}>
        <Typography variant="h6">
          3/Feb/2022 - 15/May/2022
        </Typography>
      </div>
      {/* <Typography component="h1" variant="h5">
        {title ? <FormattedMessage id={title} />:
          <LinearProgress />}
      </Typography> */}
      {!isOpen&&(loadedCountDown ?
        <Countdown date={countdownDate} renderer={countDownRenderer} /> :
        <LinearProgress/>
      )}
      {/* {readSales && readSales._address && isOpen &&
        <LinearProgress className={classes.progress} variant="determinate" value={progress} />
      } */}
      {/* <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.ContractAddress" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={address !== undefined} />
          {address !== undefined &&
            <Link href={config.etherscan.getAddressUrl(address)} target="_blank">
              {address}
            </Link>
          }
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.Cap" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={cap !== undefined} />
          {cap ? cap + "EAR" : ""}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.Goal" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={goal !== undefined} />
          {goal ? goal + "EAR" : ""}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.OpeningTime" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={openingTime !== undefined} />
          {openingTime}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.ClosingTime" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={closingTime !== undefined} />
          {closingTime}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.TokenUnlockTime" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={tokenUnlockTime !== undefined} />
          {tokenUnlockTime}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.Rate" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={rate !== undefined} />
          {rate ? rate/100+"EAR = $0.01":""}
        </Grid>
      </Grid> */}
    </Container>
  );
}
export default TokenSalesHeader;
